// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const miplayColors: ColorType = {
  ...colorPalette,
  primary: '#28ABE2',
  secondary: '#28ABE2',
  signColor: 'linear-gradient(132.34deg, #EEEEEE 0%, #D8D8D8 100%)',
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
}

export const darkTheme = {
  colors: miplayColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: miplayColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: miplayColors.primaryGray,
    secondary: miplayColors.secondaryGray,
    disabled: miplayColors.grayText,
    link: miplayColors.secondaryGray,
    hint: miplayColors.white,
    highlight: miplayColors.secondary,
    gray: miplayColors.primaryGray,
    seeAll: miplayColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: miplayColors.primaryGray,
    gray: miplayColors.secondaryGray,
  },
  filter: {
    primary: miplayColors.primaryGray,
    secondary: miplayColors.secondaryGray,
    disabled: miplayColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: miplayColors.dark,
    color: miplayColors.white,
    border: miplayColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: miplayColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: miplayColors.dark,
        selected: miplayColors.dark,
        progress: rgba(miplayColors.primary, 0.3),
        past: rgba(miplayColors.primary, 0.3),
        pastSelected: miplayColors.dark,
        pastHover: miplayColors.dark,
        empty: '#555555',
        emptyProgress: rgba(miplayColors.primary, 0.1),
      },
      text: {
        empty: miplayColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: miplayColors.white,
    subTitle: miplayColors.secondaryGray,
    bg: miplayColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
    hideBgImage: true,
  },
}
